export const GlobalColors: Record<string, string> = {
	newGradient: 'linear-gradient(90deg, #FF3598 0%, #FF5436 100%);',
	black25: 'rgba(0, 0, 0, 0.25)',
	black100: 'rgba(24, 24, 27, 1)',
	newPrimary: 'rgba(255, 53, 152, 1)',
	newPurple: 'rgba(145, 71, 255, 1)',

	darkPurlpe: '#1c1b32',
	darkPurple2: '#18181b',
	darkPurple3: '#26264350',

	pinkSamen: '#FF4076',

	transparentBlack: 'rgba(0, 0, 0, 0.95)',
	transparentWhite: 'rgba(255, 255, 255, 0.2)',

	background: 'linear-gradient(179.58deg, #631B78 -29.11%, #262543 38.02%)',
	background80: 'linear-gradient(179.58deg, rgba(99, 27, 120, 0.8) -29.11%, rgba(38, 37, 67, 0.8) 38.02%)',
	white1: '#FFF',
	white2: '#878787',
	white3: '#9593A8',
	grey1: '#7d7d7d',

	gradient3: 'linear-gradient(177.91deg, #631B78 -122.61%, #1F1E36 36.25%)',

	highlightDark: 'linear-gradient(177.91deg, #631B78 -122.61%, #1F1E36 36.25%)',
	slightGrey: 'rgba(11, 11, 11, 1)',

	black2: '#0B0B0B',
	black3: '#161616',
	//COLOR from the new color palette
	darkerBox: '#1E1E36',
	separator: '#19172A',
	desaturatedBtn: '#393853',
	inactiveTabs: '#9392A1',
	activeTabs: '#E9E9EC',
	normalVariable: '#69A5FF',
	functionVariable: '#B47EEA',
	customVariable: '#69FFD2',
};

export const Styles: Record<string, string> = {
	cardShadow1: '0px 4px 4px rgba(0, 0, 0, 0.25)',
	searchShadow1: '0px 1px 5px rgba(0, 0, 0, 0.15)',
};

export const Rules: Record<string, string> = {
	radiusImage: '5px',
	radiusButtonCTA: '25px',
	radiusRoundContainer: '25px',
	radiusBigContainer: '10px',
	radiusContainer: '5px',
	radiusCard: '5px',
	radiusARSelection: '2px',
	radiusLarge: '20px',
};
